module.exports = __webpack_public_path__ + "static/media/stat3.5530ca28.png";